export const detailedTransactions = {
	tabTitle: "Detailed sales",
	header: {
		title: "Detailed sales report",
		subtitle: "Track products sold and view your sales in detail.",
		exportButton: "Export",
		exportLoading: "Exporting...",
		exportNotification:
			"the report will be generated and once ready it will be sent to your e-mail ({{email}})",
	},
	inlineFilters: {
		customerPlaceholder: "Filter by customer",
		employeesPlaceholder: "Filter by employee",
		paymentMethodsPlaceholder: "Filter by payment method",
		filtersButton: "Filters",
	},
	table: {
		dateTime: "DATE / TIME",
		customer: "CUSTOMER",
		document: "DOCUMENT",
		seller: "EMPLOYEE",
		products: "PRODUCTS",
		paymentMethods: "PAYMENT METHOD",
		refunded: "REFUNDED?",
		refundedBadge: "REFUNDED",
		discount: "DISCOUNT",
		value: "TRANSACTION VALUE",
		totalRow: "Total",
		emptyCustomer: "Walk-in sale",
		emptyValue: "-",
		productsCount: "{{count}} products",
		productsCount_one: "{{count}} product",
		productsCount_other: "{{count}} products",
		paymentMethodsCount: "{{count}} methods",
		paymentMethodsCount_one: "{{count}} method",
		paymentMethodsCount_other: "{{count}} methods",
		emptyState: {
			noData: {
				title: "No transactions found",
				description:
					"There are no transactions recorded in the selected period. When new sales occur, they will appear here.",
			},
			noFilters: {
				title: "No transactions for the applied filters",
				description:
					"Try adjusting the period, customer, employee, payment method or sector to find what you are looking for.",
			},
		},
		pagination: {
			pageSizeLabel: "Results per page",
		},
	},
	expandedProducts: {
		name: "Product",
		fiscalCode: "Fiscal code",
		category: "Category",
		count: "Qty",
		value: "Unit value",
		discount: "Discount",
		total: "Total",
	},
	filterModal: {
		title: "Filters",
		cancel: "Cancel",
		clearFilters: "Clear filters",
		apply: "Apply",
		filteredBy: "Filtered by",
		filterOptionsLabel: "Filter options",
		clearSelection: "Clear selection",
		nav: {
			dateOrPeriod: "Date or period",
			operation: "Customer and employee",
			payment: "Payment",
			sector: "Sector",
		},
		period: {
			today: "Today",
			yesterday: "Yesterday",
			last30Days: "Last 30 days",
			customPeriod: "Custom period",
		},
		periodLabels: {
			today: "Today",
			yesterday: "Yesterday",
			last_30_days: "Last 30 days",
			custom: "Custom",
		},
		activeFilterLabels: {
			period: "period",
			customer: "customer",
			employee: "employee",
			payment: "payment",
			sector: "sector",
		},
		operationSection: {
			customerLabel: "Customer",
			customerPlaceholder: "Filter by customer",
			employeeLabel: "Employee",
			employeePlaceholder: "Filter by employee",
			noEmployeeFound: "No employee found",
		},
		paymentSection: {
			paymentLabel: "Payment method",
			paymentPlaceholder: "Filter by payment method",
			noPaymentFound: "No payment method found",
		},
		sectorSection: {
			sectorLabel: "Sector",
			sectorPlaceholder: "Filter by sector",
			noSectorFound: "No sector found",
		},
	},
};
